import React from 'react';
import { Badge } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { formatDimensions, formatWeight } from '../../../../shared/units';

const FIT_VARIANTS = { ok: 'success', too_big: 'danger', over_volume: 'danger', unknown: 'secondary' };

/** Weight with contents, outer dimensions, fit and template filling of one project case. */
const CaseHeaderInfo = ({ bundle }) => {
  const { t } = useTranslation();
  const fit = bundle.fit || { status: 'unknown', fill_percent: null };
  const availability = bundle.availability;

  return (
    <div className="small d-flex flex-column gap-1">
      <div className="d-flex flex-wrap gap-3">
        <span>
          <span className="text-muted">{t('projects.cases.weight')}: </span>
          <strong data-testid={`case-weight-${bundle.id}`}>
            {formatWeight(bundle.total_weight_display, bundle.weight_symbol)}
          </strong>
        </span>
        <span>
          <span className="text-muted">{t('projects.cases.outerDimensions')}: </span>
          <strong data-testid={`case-dimensions-${bundle.id}`}>
            {formatDimensions(bundle.outer_length, bundle.outer_width, bundle.outer_height, bundle.outer_dimension_unit_symbol)}
          </strong>
        </span>
      </div>
      <div className="d-flex flex-wrap align-items-center gap-2">
        <Badge bg={FIT_VARIANTS[fit.status] || 'secondary'} data-testid={`case-fit-${bundle.id}`}>
          {t(`projects.cases.fit.${fit.status}`)}
        </Badge>
        {fit.fill_percent !== null && fit.fill_percent !== undefined && (
          <span className="text-muted">{t('projects.cases.fill', { percent: fit.fill_percent })}</span>
        )}
        {(bundle.template || []).map((entry) => (
          <Badge
            key={entry.stock_item_id}
            bg={entry.packed >= entry.limit ? 'success' : 'light'}
            text={entry.packed >= entry.limit ? undefined : 'dark'}
            className="fw-normal"
          >
            {entry.product_name} {entry.packed}/{entry.limit}
          </Badge>
        ))}
      </div>
      {availability?.exceeded && (
        <div className="text-warning fw-medium" role="alert">
          {t('projects.cases.availabilityWarning', { planned: availability.planned, limit: availability.limit })}
        </div>
      )}
    </div>
  );
};

export default CaseHeaderInfo;
